import { useMemo } from 'react';
import { getTollIcon, getTollLength } from '../../../../entities/toll/utils';
import { TollsInfo } from 'common/utils/Route';
import { HereLayer } from 'common/utils/MapMarker';
import { ActiveTollPoint, useTollOperations } from 'entities/toll';

export const useTollMarkerLayer = (tollCraniates: TollsInfo[]) => {
  const { setActiveTollSection } = useTollOperations();
  const data = useMemo(
    () =>
      tollCraniates.reduce<ActiveTollPoint[]>((acc, { tollSections, ...point }) => {
        tollSections.forEach((tollSection) => {
          const startTollSection = tollSections.find(
            ({ startPoint }) =>
              startPoint.lat === tollSection.startPoint.lat && startPoint.lng === tollSection.startPoint.lng
          );

          const endTollSection = tollSections.find(
            ({ endPoint }) => endPoint.lat === tollSection.endPoint.lat && endPoint.lng === tollSection.endPoint.lng
          );
          acc.push({
            ...point,
            points: {
              lat: tollSection.startPoint.lat,
              lng: tollSection.startPoint.lng,
            },
            tollSection: startTollSection!,
            isStartPoint: true,
            totalLength: getTollLength(tollSections),
          });
          acc.push({
            ...point,
            points: {
              lat: tollSection.endPoint.lat,
              lng: tollSection.endPoint.lng,
            },
            tollSection: endTollSection!,
            isStartPoint: false,
            totalLength: getTollLength(tollSections),
          });
        });

        return acc;
      }, []),
    [tollCraniates]
  );

  const useHereTollMarkersLayer = useMemo(
    (): HereLayer<ActiveTollPoint[]> => ({
      data,
      name: 'toll-marker',
      type: 'marker',
      getCoordinates: ({ data: { points: {
        lat,
        lng
      } } }: any) => ({
        latitude: lat,
        longitude: lng
      }),
      getIcon: () => {
        const { url, height, width } = getTollIcon();

        return {
          url,
          width,
          height,
          anchorY: height,
          anchorX: width / 2
        };
      },
      onClick: ({ data }) => {
        setActiveTollSection(data);
      },
    }),
    [data, setActiveTollSection]
  );

  return useHereTollMarkersLayer;
};
